export const calcDate = (date1, date2) => {
  var date3 = date2 - date1

  var days = Math.floor(date3 / (24 * 3600 * 1000))

  var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))

  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))

  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(date3 / 1000)
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }
}

/**
 * 日期格式化
 */
export function dateFormat (d, format = 'yyyy-MM-dd hh:mm:ss') {
  let date = new Date(d)
  if (date != 'Invalid Date') {
    var o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      'S': date.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1,
          RegExp.$1.length == 1 ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  }
  return ''
}


export function formatTime(value){
    if (value == undefined) {
        value = 0;
      }
      var second = parseInt(value); // 秒
      var min = 0; // 分
      var hour = 0; // 小时
      if (second >= 60) {
        min = parseInt(second / 60);
        second = parseInt(second % 60);
        if (min >= 60) {
          hour = parseInt(min / 60);
          min = parseInt(min % 60);
        }
      }
      var result = "" ;
      if(second>=0){
          result+= parseInt(second) + "秒"
      }
      if(min==0&&hour==0&&second==0){
          result="";
      }
      if (min > 0) {
        result = "" + parseInt(min) + "分" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + "时" + result;
      }
      return result;
}




// WEBPACK FOOTER //
// ./src/utils/date.js